import EmailDisplay from './Email.vue'
import HelpTooltip from './HelpTooltip'

export default {
    EmailDisplay,
    HelpTooltip
}
